import * as S from "./styles.ts";
import { DropZone } from "@measured/puck";

interface IFlexBoxProps {
  gap?: number;
  flexWrap?: boolean;
  justifyContent?: string;
  alignItems?: string;
  width?: string;
  flexDirection?: string;
  autoMaxWidth?: boolean;
  padding?: {
    vertical: number;
    horizontal: number;
  };
  reverse?: boolean;
}

const FlexBox = ({
  gap,
  flexWrap,
  justifyContent,
  alignItems,
  width,
  autoMaxWidth,
  flexDirection,
  padding,
  reverse,
}: IFlexBoxProps) => {
  return (
    <S.FlexBox
      $gap={gap}
      $flexWrap={flexWrap ? "wrap" : "nowrap"}
      $justifyContent={justifyContent}
      $autoMaxWidth={autoMaxWidth}
      $alignItems={alignItems}
      $flexDirection={`${flexDirection}${reverse ? "-reverse" : ""}`}
      $width={width}
      $padding={padding}
    >
      <DropZone zone="flex-box" />
    </S.FlexBox>
  );
};

export default FlexBox;
